import React, { useState } from 'react';
import MultiSelectDropdown from 'LearningManager/components/MultiSelectDropdown';
import Carousel from 'LearningManager/components/Carousel';
import CourseCard from 'LearningManager/components/CourseCard';
import Heading from 'LearningManager/components/Heading';
import {
	PRIORITY_OPTIONS,
	STATUS_OPTIONS,
	TYPE_OPTIONS,
	CATEGORY_OPTIONS,
	COURSE_GROUPS_DATA,
	LEARNING_PATHS_DATA
} from 'LearningManager/constants/UserDashboard.constants';
import LearningPathCard from 'LearningManager/components/LearningPathCard';
import { Icon } from 'Components';
import styles from './TrainingSection.module.scss';

const TrainingSection: React.FC = () => {
	return (
		<div>
			<div className={styles.header}>
				<span className={styles.title}>Training</span>
				<div className={styles.filters}>
					<MultiSelectDropdown
						placeholder="Priority (All)"
						options={PRIORITY_OPTIONS}
						className={styles.filter}
					/>
					<MultiSelectDropdown
						placeholder="All states"
						options={STATUS_OPTIONS}
						className={styles.filter}
					/>
					<MultiSelectDropdown
						placeholder="All types"
						options={TYPE_OPTIONS}
						className={styles.filter}
					/>
					<MultiSelectDropdown
						placeholder="All categories"
						options={CATEGORY_OPTIONS}
						className={styles.filter}
					/>
				</div>
			</div>

			<LearningPathsSection />
			<CoursesSection />
		</div>
	);
};

const LearningPathsSection: React.FC = () => {
	return (
		<div className={styles.section}>
			<Heading
				icon={<Icon className={styles.icon} type="darkLP" role="img" />}
				title="Learning Paths"
			/>
			<div className={styles.learningPathsWrapper}>
				{LEARNING_PATHS_DATA.map((lp) => (
					<LearningPathCard key={lp.id} learningPath={lp} />
				))}
			</div>
		</div>
	);
};

const CoursesSection: React.FC = () => {
	const [selectedKeys, setSelectedKeys] = useState<Set<string>>(new Set());

	const toggleSelection = (key: string) => {
		setSelectedKeys((prev) => {
			const next = new Set(prev);
			next.has(key) ? next.delete(key) : next.add(key);
			return next;
		});
	};

	return (
		<div className={styles.section}>
			<Heading
				icon={
					<Icon
						className={styles.icon}
						type="darkIndiCourses"
						role="img"
					/>
				}
				title="Courses"
			/>
			<div className={styles.coursesWrapper}>
				{COURSE_GROUPS_DATA.map((group) => (
					<div key={group.scope} id={`lms-ud-courses-${group.scope}`}>
						<Carousel
							data={group.courses}
							label={group.label}
							labelClassName={styles.subLabel}
							itemsPerPage={4}
							renderItem={(course) => {
								const key = `${group.scope}-${course.id}`;
								const isComplete = course.tags.includes('Complete');
								const isSelected = selectedKeys.has(key);
								const showReview = isComplete || isSelected;
								return (
									<CourseCard
										index={course.id}
										htmlId={`lms-ud-course-${key}`}
										course={{
											...course,
											isSelected
										}}
										onClick={() => null}
										onSelect={() => toggleSelection(key)}
										ctaLabel={showReview ? 'Review' : 'Start'}
										ctaVariant={showReview ? 'border' : undefined}
										ctaClassName={showReview ? styles.reviewBtn : undefined}
										checkedClassName={styles.selectedCheck}
										hideBadge
										hideRequiredSection
									/>
								);
							}}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default TrainingSection;
